import { Box, Typography, Button } from "@mui/material";
import primaryBg from "../../assets/Backgrounds/primaryBg.svg";
import home_RotatingIcon from "../../assets/home_Rotating.svg";
import aboutImage from "../../assets/Backgrounds/Profile_boy.webp";
import { useState, useEffect } from "react";
import 'aos/dist/aos.css'; // Import AOS styles
import './CsrCarousel.css'; // Import custom carousel styles
import PrimaryButton from '../../PrimaryButton';

const SlickArrowLeft = ({ onClick }) => (
  <div
    className="slick-arrow-csr slick-left-csr"
    onClick={onClick}
    data-aos="fade-right-csr"
    data-aos-delay="200"
  >
    &larr;
  </div>
);

const SlickArrowRight = ({ onClick }) => (
  <div
    className="slick-arrow-csr slick-right-csr"
    onClick={onClick}
    data-aos="fade-left-csr"
    data-aos-delay="200"
  >
    &rarr;
  </div>
);

const OurCsr = ({ csr = [], csrEvent = [] }) => {
  const [csrImage, setCsrImage] = useState(null);
  const [description, setDescription] = useState(null);
  const [stemEvents, setStemEvents] = useState([]);
  const [filteredCsr, setFilteredCsr] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const currentYear = new Date().getFullYear(); // 2025

  useEffect(() => {
    if (!csr || !csrEvent) return; // Guard against undefined/null
    const filteredEvents = [];
    // Filter for csr items with csr_type === 'mia'
    const miaCsr = csr.filter(item => item.csr_type === 'mia');
    if (miaCsr) {
      setFilteredCsr(miaCsr);
    }
    let firstImage = csrImage;
    let firstDescription = description;

    miaCsr.forEach(csr => {
      if (csr.csr_type === 'mia') {
        if (!firstImage) firstImage = csr.image;
        csrEvent.forEach(event => {
          const eventYear = new Date(event.dateCreated).getFullYear();
          if (eventYear === currentYear && event.csrId === csr.id) {
            filteredEvents.push({ ...event });
            if (!firstDescription) firstDescription = csr.description;
          }
        });
      }
    });

    if (!csrImage && firstImage) setCsrImage(firstImage);
    if (!description && firstDescription) setDescription(firstDescription);
    setStemEvents(filteredEvents);
  }, [csr, csrEvent, csrImage, description]);

  useEffect(() => {
    window.AOS?.refresh();
  }, [currentSlide]);

  const goToPrev = () => {
    if (filteredCsr.length > 0) {
      setCurrentSlide(prev => (prev === 0 ? filteredCsr.length - 1 : prev - 1));
    }
  };

  const goToNext = () => {
    if (filteredCsr.length > 0) {
      setCurrentSlide(prev => (prev === filteredCsr.length - 1 ? 0 : prev + 1));
    }
  };

  const displayCsrEvents = () => {
    return stemEvents.length > 0 ? (
      stemEvents.map((event, index) => (
        <Box key={index}>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 1)',
              borderRadius: '10px',
              border: '.1rem solid gray',
              padding: '.5rem',
              boxShadow: 3,
              width: '100%',
              maxWidth: '1200px',
              overflow: 'hidden'
            }}
          >
            <Box
              sx={{
                width: { xs: '300px', sm: '300px', md: '450px' },
                borderRadius: '10px',
                overflow: 'hidden',
              }}
              data-aos="fade-left"
              data-aos-delay={200 + index * 100}
            >
              <img
                src={
                  event.image
                    ? `https://mindsinaction.com.na/assets/media/pictures/${event.image}`
                    : aboutImage
                }
                alt={event.title}
                style={{ width: '100%', objectFit: 'cover' }}
              />
            </Box>
            <Box
              minWidth={'300px'}
              sx={{
                flex: 1,
                textAlign: 'justify',
                padding: { xs: '1rem', sm: '0' },
              }}
              data-aos="fade-right"
              data-aos-delay={300 + index * 100}
            >
              <Typography
                variant="h6"
                color="#000000ff"
                fontSize={{xs: '.9rem', sm: '.9rem', md: '1rem'}}
                sx={{ mb: 1, padding: '1rem'}}
              >
                {event.description}
              </Typography>
              <div style={{float: 'right', marginRight: '2rem', marginTop: '2rem'}}>
                <PrimaryButton tittle="Read More" bcolor="#f0f0f0ff" tcolor="#90ca25" />
              </div>
            </Box>
          </Box>
        </Box>
      ))
    ) : (
      <Box
        sx={{
          padding: '2rem',
          textAlign: 'center',
          width: { xs: '90%', sm: '80%' },
          maxWidth: '800px',
          mx: 'auto',
        }}
        data-aos="fade-in"
        data-aos-delay="100"
      >
        <Typography variant="h6" color="#134e9cff">
          No STEM events available for {currentYear}.
        </Typography>
      </Box>
    );
  };

  return (
    <>
      {
        filteredCsr.length <= 0 ? (
          <></>
        ):(
          <Box
            sx={{
              position: 'relative',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              width="100%"
              height={'100px'}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 1)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <h1 
                className='primary-header'
                style={{color: '#3b76b2', textAlign: 'center'}}
                data-aos="fade-down"
                data-aos-delay="200"
              >
                CORPORATE SOCIAL RESPONSIBILITIES
              </h1>
            </Box>

            {/* Carousel Section */}
            <Box
              sx={{
                padding: '0 50px',
                backgroundColor: 'rgba(255, 255, 255, 1)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                position: 'relative',
              }}
            >
              {filteredCsr.length > 0 ? (
                <Box>
                  {filteredCsr.length > 1 && <SlickArrowLeft onClick={goToPrev} />}
                  <Box
                    sx={{
                      position: 'relative',
                      width: '100%',
                      maxWidth: '1200px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {filteredCsr.map((csrItem, index) => (
                      <Box
                        key={csrItem.id}
                        sx={{
                          display: index === currentSlide ? 'flex' : 'none',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          margin: { xs: '1rem 0', sm: '2rem 0' },
                          width: '100%',
                        }}
                        data-aos="fade-up"
                        data-aos-delay={csrItem.id * 100}
                      >
                        <Box width={'100%'} display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
                          {displayCsrEvents()}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  {filteredCsr.length > 1 && <SlickArrowRight onClick={goToNext} />}
                </Box>
              ) : (
                <Box
                  sx={{
                    padding: '2rem',
                    textAlign: 'center',
                    width: { xs: '90%', sm: '80%' },
                    maxWidth: '800px',
                    mx: 'auto',
                  }}
                  data-aos="fade-in"
                  data-aos-delay="100"
                >
                  <Typography variant="h6" color="#134e9cff">
                    No CSR items available.
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        )
      }
    </>
    
  );
};

export default OurCsr;